import { useEffect } from "react";
import socket from "../socket";

const useSocket = (userId) => {

    useEffect(() => {
        if (!userId) return;

        socket.auth = { userId };
        socket.connect();

        socket.on("connect", () => {
            console.log("Socket connected:", socket.id);
        });

        socket.on("connect_error", (err) => {
            console.error("Socket connection error:", err.message);
        });

        socket.on("disconnect", (reason) => {
            console.log("Socket disconnected:", reason);
        });

        return () => {
            socket.disconnect();
            socket.off("connect");
            socket.off("connect_error");
            socket.off("disconnect");
        };
    }, [userId]);

};

export default useSocket;